import { graphql } from "@opensea/graphql"

export const useSetBlockchainActionErrorsFragment = graphql(`
  fragment useSetBlockchainActionErrors on TransactionError {
    __typename
    ... on OrderNotFound {
      item {
        id
        chain {
          identifier
        }
      }
    }
  }
`)
